import React, { useState } from "react";
import SubcontractorAdhocFeeTable from "./components/SubcontractorAdhocFeeTable";
import {
  Card,
  CardContent,
  Grid,
  makeStyles,
  Tab,
  Tabs,
} from "@material-ui/core";
import TabPanel from "../routeplans/components/TabPanel";
import SanitizedGrid from "../../components/SanitizedGrid";
import HeaderContent from "../../components/layout/components/HeaderContent";

const useStyles = makeStyles({
  sidePanelTabs: {
    borderBottom: "1px solid #C4C4C4",
    "& .MuiTabs-fixed > .MuiTabs-indicator": {
      backgroundColor: "#989898 !important",
      height: "3px !important",
    },
  },
});

const SubcontractorAdhocFeeList = () => {
  const [valueAdhocFeeListTab, setValueAdhocFeeListTab] = useState(0);
  const [valueIssuedAdhocFeeListTab, setValueIssuedAdhocFeeListTab] =
    useState(0);

  const classes = useStyles();

  const handleChangeAdhocFeeListTab = (
    event: React.ChangeEvent<{}>,
    newValue: number
  ) => {
    setValueAdhocFeeListTab(newValue);
  };
  const adhocFeeListProps = (index: number) => {
    return {
      id: `adhocFeeList-tab-${index}`,
      "aria-controls": `adhocFeeList-tabpanel-${index}`,
    };
  };

  const handleChangeIssuedAdhocFeeListTab = (
    event: React.ChangeEvent<{}>,
    newValue: number
  ) => {
    setValueIssuedAdhocFeeListTab(newValue);
  };
  const issuedAdhocFeeListProps = (index: number) => {
    return {
      id: `issuedAdhocFeeList-tab-${index}`,
      "aria-controls": `issuedAdhocFeeList-tabpanel-${index}`,
    };
  };

  const breadcrumb = [
    { link: "/subcontractorAdhocFees", title: "Subcontractor Adhoc Fees" },
  ];

  return (
    <>
      <HeaderContent
        breadcrumb={breadcrumb}
        headerTitle="Subcontractor Adhoc Fees"
        isNotHaveSchoolFilter
      />

      <Card>
        <CardContent>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Tabs
                value={valueAdhocFeeListTab}
                onChange={handleChangeAdhocFeeListTab}
                aria-label="Adhoc Fee List"
                className={classes.sidePanelTabs}
              >
                <Tab label="Unapproved Adhoc Fees" {...adhocFeeListProps(0)} />
                <Tab label="Approved Adhoc Fees" {...adhocFeeListProps(1)} />
                <Tab label="Rejected Adhoc Fees" {...adhocFeeListProps(2)} />
              </Tabs>

              <TabPanel value={valueAdhocFeeListTab} index={0}>
                <Grid item xs={12}>
                  <SubcontractorAdhocFeeTable
                    hasIssued={false}
                    status="Pending"
                    isFixedHeight
                    isShowTitle
                  />
                </Grid>
              </TabPanel>

              <TabPanel value={valueAdhocFeeListTab} index={1}>
                <Grid item xs={12}>
                  <SubcontractorAdhocFeeTable
                    hasIssued={false}
                    status="Approved"
                    isFixedHeight
                    isShowTitle
                  />
                </Grid>
              </TabPanel>

              <TabPanel value={valueAdhocFeeListTab} index={2}>
                <Grid item xs={12}>
                  <SubcontractorAdhocFeeTable
                    hasIssued={false}
                    status="Rejected"
                    isFixedHeight
                    isShowTitle
                  />
                </Grid>
              </TabPanel>
            </Grid>

            <Grid item xs={12}>
              <Tabs
                value={valueIssuedAdhocFeeListTab}
                onChange={handleChangeIssuedAdhocFeeListTab}
                aria-label="Issued Adhoc Fee List"
                className={classes.sidePanelTabs}
              >
                <Tab
                  label="Issued Adhoc Fees"
                  {...issuedAdhocFeeListProps(0)}
                />
              </Tabs>
              <TabPanel value={valueIssuedAdhocFeeListTab} index={0}>
                <Grid item xs={12}>
                  <SubcontractorAdhocFeeTable
                    hasIssued={true}
                    status="Approved"
                    isFixedHeight
                  />
                </Grid>
              </TabPanel>
            </Grid>
          </SanitizedGrid>
        </CardContent>
      </Card>
    </>
  );
};

export default SubcontractorAdhocFeeList;
